<script lang="ts">
    import { Navigation } from '../../utilities/Navigation';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import IconAdd from '../../shared/Icons/IconAdd.svelte';
    import { currentMainFilter } from '../../../stores/filter';
    import { mainMenu } from '../../../stores/store';
    import Separator from '../../shared/Separator.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import ExportSection from './ExportSection.svelte';
    import { ExportType } from './ExportType';
    import TemplateSettingsGeneral from '../Settings/TemplateSettingsGeneral.svelte';

    let downloadingInProgress: boolean = false;

    onMount(() => {
        $mainMenu.currentPage = 'PageExports';
        $currentMainFilter = null;
        return () => {
            $currentMainFilter = null;
        };
    });

    $: downloadingInProgress = downloadingInProgress;
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                {$_('Export')}
            </div>
            <div slot="main-buttons"></div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content">
        <Separator />
        <TemplateSettingsGeneral>
            <!--    <div slot="label">{$_('Czy aktywna')}</div>-->
            <div slot="content">
                <ExportSection
                    et={new ExportType('location', 'location')}
                    label={$_('Points list')}
                    bind:downloadingInProgress
                />
                <ExportSection
                    et={new ExportType('connection', 'connection')}
                    label={$_('Connections (routes) list')}
                    bind:downloadingInProgress
                />
                <ExportSection
                    et={new ExportType('connection_calc', 'connection_calc')}
                    label={$_('Calculated routes costs list')}
                    bind:downloadingInProgress
                />
            </div>
        </TemplateSettingsGeneral>
    </div>
</TemplateStandard>

<style>
</style>
